/**
 * The card surfaces of the app, so a panel on one screen looks like a panel on every other.
 * The app had 56 hand-written recipes for the same three things.
 *
 * - `SURFACE_CARD`: a block of content on the page (a list, a summary, a form section). Add
 *   only padding (`p-4`, or `p-5` for a titled block). A titled panel can be a `BaseDataCard`.
 * - `SURFACE_INSET`: a quieter area INSIDE a card or drawer (a sub-panel, a preview).
 * - `SURFACE_SELECTABLE`: a card the person clicks to pick it; add `aria-pressed` and the
 *   selected state with `SURFACE_SELECTED`.
 */
export const SURFACE_CARD = 'rounded-lg border border-border bg-surface shadow-xs';

export const SURFACE_INSET = 'rounded-lg border border-border-subtle bg-muted';

export const SURFACE_SELECTABLE =
  'interactive rounded-lg border border-border bg-surface text-left shadow-xs hover:border-brand-border';

export const SURFACE_SELECTED = 'border-brand bg-brand-soft';
